import { render, staticRenderFns } from "./ContactPersonDialog.vue?vue&type=template&id=3ee36688&scoped=true"
import script from "./ContactPersonDialog.vue?vue&type=script&lang=js"
export * from "./ContactPersonDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactPersonDialog.vue?vue&type=style&index=0&id=3ee36688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee36688",
  null
  
)

export default component.exports